import axios from '../library/axiosConfig';

export default {
  // 电话评分 
  addServiceEvaluate (data) {
    return axios.post('evaluate/addServiceEvaluate', data, {baseURL: axios.defaults.baseRenterbehavior});
  },
  // 查询预约房间信息
  findRoomDetail (data) {
    return axios.post('renterbehavior/reservation/findRoomDetail', data, {baseURL: axios.defaults.baseRenterbehavior});
  },
  // 查询预约房间信息(品牌定制)
  findRoomDetailBrandCustom (data) {
    return axios.post('h5/renterbehavior/v1/brandreservation/findRoomDetail', data, {baseURL: axios.defaults.baseRenterbehavior});
  },
  // 房间预约
  addRoomOrder (data) {
    return axios.post('renterbehavior/reservation/addReservationOrder', data, {baseURL: axios.defaults.baseRenterbehavior});
  },
  // 房间预约（品牌定制）
  addRoomOrderBrandCustom (data) {
    return axios.post('h5/renterbehavior/v1/brandreservation/addReservationOrder', data, {baseURL: axios.defaults.baseRenterbehavior});
  },
  // 预约列表
  findOrderList (data) {
    return axios.post('renterbehavior/look/querySchedules', data, {baseURL: axios.defaults.baseRenterbehavior, brandCustomBody: true});
  },
  // 预约列表
  queryReservationorder (data) {
    return axios.post('renterbehavior/look/queryReservationorder', data, {baseURL: axios.defaults.baseRenterbehavior, brandCustom: true});
  },
  // 看房行程
  querySchedules (data) {
    return axios.post('renterbehavior/look/v2/querySchedules', data, {baseURL: axios.defaults.baseRenterbehavior});
  },
  // 看房行程评价
  addScheduleEvaluate (data) {
    return axios.post('/evaluate/addScheduleEvaluate', data, {baseURL: axios.defaults.baseRenterbehavior});
  },
  // 房间是否可以预约
  canOrder (data) {
    return axios.post('renterbehavior/reservation/isRoomAvailable', data, {baseURL: axios.defaults.baseRenterbehavior});
  },
  // 房间是否可以预约（品牌定制）
  canOrderBrandCustom (data) {
    return axios.post('h5/renterbehavior/v1/brandreservation/isRoomAvailable', data, {baseURL: axios.defaults.baseRenterbehavior});
  },
  /**
   * 电话评分埋点
   * @param data
   * @returns {AxiosPromise<any>}
   */
  addUserBehavior (data) {
    return axios.post(`behavior/addUserBehaviorRecord`, data, {baseURL: axios.defaults.baseRenterbehavior});
  },
  /**
   * 举报内容提交
   * @param data
   * @returns {AxiosPromise<any>}
   */
  setReport (data) {
    return axios.post(`complain/addComplain`, data, {
      json: true,
      baseURL: axios.defaults.baseRenterbehavior
    });
  },
  /**
   * 添加租客评价信息
   * @param data
   * @returns {AxiosPromise<any>}
   */
  addRoomEvaluate (data) {
    return axios.post(`/h5/roomEvaluate/addRoomEvaluate`, data, {baseURL: axios.defaults.baseRenterbehavior, json: true});
  },
  /**
   * 查询房间基本信息
   * @param data
   * @returns {AxiosPromise<any>}
   */
  findRoomBaseInfo (data) {
    return axios.post(`/h5/roomEvaluate/findRoomBaseInfo`, data, {baseURL: axios.defaults.baseRenterbehavior});
  },
  /**
   * 加载租客评价标签
   * @param data
   * @returns {AxiosPromise<any>}
   */
  loadEvaluateTag (data) {
    return axios.post(`/h5/roomEvaluate/loadEvaluateTag`, data, {baseURL: axios.defaults.baseRenterbehavior});
  },
  /**
   * 查询租约评价信息
   * @param data
   * @returns {AxiosPromise<any>}
   */
  queryRentOrderEvaluateInfo (data) {
    return axios.post(`/h5/roomEvaluate/queryRentOrderEvaluateInfo`, data, {baseURL: axios.defaults.baseRenterbehavior});
  }
};



// WEBPACK FOOTER //
// ./src/api/mogoroomRenterBehavior.js